export const GROUPING_NONE = 'none';
export const GROUPING_CENTER = 'center';
export const GROUPING_CLASS = 'class';
